import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Store } from '@ngxs/store';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { ProviderService } from '../../service/provider.service';
import { AuthState } from '../..//store/authInfo/auth-state';
import { ProviderDetailComponent } from './provider-detail/provider-detail.component';
import { ProviderComponent } from './provider/provider.component';

@Component({
  selector: 'app-provider-manager',
  templateUrl: './provider-manager.component.html',
  styleUrls: ['./provider-manager.component.less']
})
export class ProviderManagerComponent implements OnInit {

  pageIndex: number;
  pageSize: number;
  total = 0;
  loading = true;
  // 查询结果
  data = [];
  validateForm: FormGroup;
  authState = null;
  checked = false;
  indeterminate = false;
  setOfCheckedId = new Set<number>();
  typeMap = new Map<number, any>();
  pTypes = [];
  performanceEvaluations = ['', '很差', '较差', '一般', '良好', '优秀'];
  qualifyReviews = ['未审', '已审'];
  comprehensiveEvaluations = ['', '弃用', '观察试用', '继续留用'];
  constructor(
    private modalService: NzModalService,
    private message: NzMessageService,
    private providerService: ProviderService,
    private fb: FormBuilder,
    private store: Store,
  ) { }

  async ngOnInit(): Promise<void> {
    this.authState = this.store.selectSnapshot<any[]>(AuthState);
    this.validateForm = this.fb.group({
      pName: [null], // 供应商名称
      pCode: [null],
      typeId: [null],
      typeIds: [null]
    });
    await this.providerService.getProviderTypeList().then((data) => {
      this.initTypeTree(data);
    });
    this.queryProviderData(1);
  }
  onAllChecked(checked: boolean): void {
    this.data.forEach(item => this.updateCheckedSet(item.pno, checked));
    this.refreshCheckedStatus();
  }

  updateCheckedSet(id: number, checked: boolean): void {
    if (checked) {
      this.setOfCheckedId.add(id);
    } else {
      this.setOfCheckedId.delete(id);
    }
  }
  onItemChecked(id: number, checked: boolean): void {
    this.updateCheckedSet(id, checked);
    this.refreshCheckedStatus();
  }
  refreshCheckedStatus(): void {
    this.checked = this.data.every(item => this.setOfCheckedId.has(item.pno));
    this.indeterminate = this.data.some(item => this.setOfCheckedId.has(item.pno)) && !this.checked;
  }
  onPageIndexChange(pageIndex) {
    this.pageIndex = pageIndex;
    this.queryProviderData(2);
  }
  // 提交表单
  submitForm() {
    let allTypes: number[] = [];
    if (this.validateForm.value.typeId instanceof Array) {
      for (const id of this.validateForm.value.typeId) {
        const types: number[] = this.getAllTypes(id);
        allTypes = allTypes.concat(types);
      }
    }
    this.validateForm.setValue({
      pName: this.validateForm.value.pName, // 供应商名称
      pCode: this.validateForm.value.pCode, // 供应商代码
      typeIds: allTypes,
      typeId: this.validateForm.value.typeId,
    });
    this.queryProviderData(1);
  }
  // 重置表单
  resetForm() {
    this.validateForm.reset();
    this.queryProviderData(1);
  }
  details(item){
    const modal = this.modalService.create({
      nzTitle: '查看供应商',
      nzContent: ProviderComponent,
      nzStyle: { top: '20px' },
      nzBodyStyle: { paddingRight: '0px', paddingLeft: '42px' },
      nzWidth: 700,
      nzComponentParams: {
        code: 2,
        pno: item.pno
      },
      nzOnOk: (ev) => {
      },
      nzOnCancel: (ev) => {
      }
    });
  }
  viewProvider(item) {
    const modal = this.modalService.create({
          nzTitle: '供应商-' + item.pname,
          nzContent: ProviderDetailComponent,
          nzStyle: { top: '20px' },
          nzBodyStyle: {padding: '0px 24px 24px 24px'},
          nzWidth: 900,
          nzComponentParams: {
            pno: item.pno
          },
          nzOnOk: (ev) => {
          },
          nzOnCancel: (ev) => {
          }
        });
  }
  editProvider(item) {
    const modal = this.modalService.create({
      nzTitle: '修改供应商',
      nzContent: ProviderComponent,
      nzStyle: { top: '20px' },
      nzBodyStyle: { paddingRight: '0px', paddingLeft: '42px' },
      nzWidth: 700,
      nzComponentParams: {
        code: 1,
        pno: item.pno
      },
      nzOnOk: (ev) => {
        this.modalService.confirm({
          nzTitle: '修改供应商',
          nzContent: '确定要修改供应商内容？',
          nzOkText: '确定',
          nzCancelText: '取消',
          nzOnOk: () => {
            const  providerForm  = ev.getProviderForm();
            if (!this.validateFormData(providerForm)){
              this.message.warning('数据未验证通过');
            }else{
              const  provider = {
                pno : item.pno,
                pname : providerForm.value.pname,
                pcode : providerForm.value.pcode,
                ptype: providerForm.value.ptype,
                paddr: providerForm.value.paddr,
                pemail: providerForm.value.pemail,
                pphone: providerForm.value.pphone,
                pcontact : providerForm.value.pcontact,
                cphone : providerForm.value.cphone,
                cemail: providerForm.value.cemail,
                qualifyReview: providerForm.value.qualifyReview,
                performanceEvaluation: providerForm.value.performanceEvaluation,
                continuUse: providerForm.value.continuUse,
                mark: providerForm.value.mark,
                updateBy: this.authState.userInfo.userId,
                director: providerForm.value.director,
              };
              // tslint:disable-next-line:no-shadowed-variable
              this.providerService.updateProvider(provider).subscribe((data: any) => {
                if (!this.isEmpty(data)){
                  this.queryProviderData(1);
                  this.message.success('修改成功');
                  modal.close();
                }else{
                  this.message.error('修改失败');
                }
              });
            }
            return true;
          }
        });
        return false;
      },
      nzOnCancel: (ev) => {
      }
    });
  }
  addProvider() {
    const modal = this.modalService.create({
      nzTitle: '添加供应商',
      nzContent: ProviderComponent,
      nzStyle: { top: '20px'},
      nzBodyStyle: { paddingRight: '0px', paddingLeft: '42px' },
      nzWidth: 700,
      nzComponentParams: {
        code: 0,
      },
      nzOnOk: (ev) => {
        const  providerForm  = ev.getProviderForm();
        if (!this.validateFormData(providerForm)){
          this.message.warning('数据未验证通过');
          return false;
        }else{
          const  provider = {
            pname : providerForm.value.pname,
            pcode : providerForm.value.pcode,
            ptype: providerForm.value.ptype,
            paddr: providerForm.value.paddr,
            pemail: providerForm.value.pemail,
            pphone: providerForm.value.pphone,
            pcontact : providerForm.value.pcontact,
            cphone : providerForm.value.cphone,
            cemail: providerForm.value.cemail,
            qualifyReview: providerForm.value.qualifyReview,
            performanceEvaluation: providerForm.value.performanceEvaluation,
            continuUse: providerForm.value.continuUse,
            mark: providerForm.value.mark,
            createBy: this.authState.userInfo.userId,
            director: providerForm.value.director,
          };
          // tslint:disable-next-line:no-shadowed-variable
          this.providerService.addProvider(provider).subscribe((data: any) => {
            if (!this.isEmpty(data)){
              this.queryProviderData(1);
              this.message.success('添加成功');
              modal.close();
            }else{
              this.message.error('添加失败');
            }
          });
          return false;
        }
      },
      nzOnCancel: (ev) => {
      }
    });
  }
  delete() {
    this.modalService.confirm({
      nzTitle: '删除',
      nzContent: '你确定要删除选中供应商?',
      nzOkText: '确定',
      nzCancelText: '取消',
      nzOnOk: () => {
        this.providerService.batchDeleteProviders(this.setOfCheckedId).subscribe((data: any) => {
          if (data > 0){
            this.queryProviderData(1);
          }
        });
      }
    });
  }
  queryProviderData(flag: number) {
    if (flag === 1) {
      this.pageIndex = 1;
      this.pageSize = 10;
    }
    // tslint:disable-next-line:max-line-length
    this.providerService.getProviderListByCondition(this.validateForm.value, this.pageIndex, this.pageSize).subscribe((data: any) => {
      this.loading = false;
      this.data = data.list;
      this.total = data.total;
    });
  }
  initTypeTree(types: any[]) {
    const pTypes = [];
    this.typeMap.clear();
    for (const type of types) {
      const node = {
        title: type.typeName,
        value: type.typeId,
        key: type.typeId,
        isLeaf: true
      };
      if (type.parentId === 0) {
        pTypes.push(node);
      } else {
        const parent = this.typeMap.get(type.parentId);
        if (parent != null) {
          if (parent.children == null) {
            parent.children = [];
            parent.isLeaf = false;
          }
          parent.children.push(node);
        }
      }
      this.typeMap.set(type.typeId, node);
    }
    this.pTypes = pTypes;
  }

  getAllTypes(id: number): number[] {
    let types: number[] = [];
    types.push(id);
    const type = this.typeMap.get(id);
    if (type != null && type.children != null) {
      for (const child of type.children) {
        types = types.concat(this.getAllTypes(child.value));
      }
    }
    return types;
  }
  public validateFormData(validateForm) {
    // tslint:disable-next-line:forin
    for (const i in validateForm.controls) {
      validateForm.controls[i].markAsDirty();
      validateForm.controls[i].updateValueAndValidity();
    }
    return validateForm.valid;
  }
  isEmpty(obj: any) {
    if (typeof obj === 'undefined' || obj === null || obj === '') {
      return true;
    } else {
      return false;
    }
  }
  convertInt(str){
    if (this.isEmpty(str)){
      return 0;
    }else{
      return Number(str);
    }
  }
}
